import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);
  return children;
};

ScrollToTop.propTypes = {
  children: PropTypes.any.isRequired,
};

export default ScrollToTop;
